<template>
  <component v-if="pageReady" :is="$component" ref="pageObj" :params="params"></component>
</template>

<script>
  import Vue from 'vue';
  import store from '@/common/vuex/store_rt'
  import {mapGetters} from 'vuex'
  export default {
    name: 'mw-inner-page',
    data() {
      return {
        $component:{},
        cssEl:null,
        pageReady:false
      }
    },
    props: {
      params: {
        type: Object
      },

      dialog: {
        type: Object
      },

      pageId: String,
      pageData:Object,
      noWrap:{
        type:Boolean,
        default:false
      },
      unitFilter:{
        type: Boolean,
        default: false
      },
      deptFilter:{
        type: Boolean,
        default: false
      }
    },
    mounted() {
      this.loadPage();
    },
    watch: {
      pageId(){
        this.loadPage();
      }
    },
    beforeDestroy() {
      this.destroy();
    },
    computed: {
      ...mapGetters([
        'curSelUnitId',
        'curSelDeptId'
      ])
    },
    methods: {
      destroy(){
        // if(this.$component){
        //   this.$component.$destroy(true);
        //   this.$component=undefined;
        // }
        if(this.cssEl){
          this.cssEl.remove();
        }
        this.pageReady=false;
      },
      insertCss:function(css){
        if(!css)return;
        this.cssEl=$("<style type='text/css'></style>").html(css).insertBefore(this.$el);
      },
      wrapTpl(tpl){
        return this.noWrap?tpl:`<div class="mw-panel">
              <div class="mw-panel mw-panel-class">
                ${tpl}
              </div>
            </div>`
      },
      getParentPage(){
          let p=this.$parent;
          do{
            if(p.getPageDef) return p;
            p=p.$parent;
          }while(p)
      },
      getPageDef(id){
          let me=this;
          return new Promise((resolve,reject)=>{
            function cacheSubPage(def) {
              if (def && def.subPages) {
                me.subPageMap={}
                def.subPages.forEach(p=>{
                  if(p)
                    me.subPageMap[p.id]=p;
                });
              }
            }
            if (me.pageData) {
              cacheSubPage(me.pageData)
              return resolve(me.pageData)
            }
            let page;
            let parentPage=me.getParentPage();
            if(parentPage && parentPage.subPageMap){
                page=parentPage.subPageMap[id];
                if(page){
                    cacheSubPage(page);
                    return resolve(page);
                }
            }
            $.ajax(`/resource/page/${id}`).then(res=>{
            //PF.fsrv("app.render.getPageStructure",id).then(res=>{
                if(res.success){
                  let def=res.result;
                  cacheSubPage(def);
                  resolve(def);
                }else{
                  reject(res);
                }
            });
          })
      },
      loadPage(){
        let me=this;
        me.destroy();
        if(!me.pageId && !me.pageData)return;
        me.getPageDef(me.pageId,true).then(page=>{
          if(!page){
            me.mwMsg("warning","没找到对应页面:"+me.pageId);
            return
          }
          this.insertCss(page.style);
          let $obj;
          if(page.script){
            let script=`(function(){
              var $obj;

              ${page.script}

              return $obj
            })()`
            $obj=eval(script);
            //eval(page.script)
          }

          if($obj){
            $obj=Object.assign({
              // el: this.$el.querySelector(".mw-panel-class"),
              template:this.wrapTpl(page.template),
              store:store,
              router:mwRouter
            },$obj);
          }else{
            $obj={
              // el: this.$el.querySelector(".mw-panel-class"),
              template:this.wrapTpl(page.template),
              store:store,
              router:mwRouter
            }
          }
          let config={};

          //单位过滤
          if(me.unitFilter){
            if(me.curSelUnitId){
              config.unitFilter=me.curSelUnitId
            }
          }
          //部门过滤
          if(me.deptFilter){
            if(me.curSelDeptId){
              config.deptFilter=me.curSelDeptId
            }
          }

          $obj.customConfig={config:config,params:me.params,dialog:me.dialog};

          // this.$component =new Vue($obj)
          me.$component=$obj;
          me.pageReady=true;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/page/index.vue